export enum VehicleIndicatorTypeEnum {

    RPM = 0,
    GPS = 1,
    GSM = 2,
    Fuel = 3,
    CANFuel = 4,
    Power = 5,
    Speed = 6,
    Ignition = 7,
    Lifter = 8,
    Cap = 9

}
